import { render } from "./AlarmReminderIndex.vue?vue&type=template&id=440f7395"
import script from "./AlarmReminderIndex.vue?vue&type=script&lang=js"
export * from "./AlarmReminderIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__